"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _IcdCodeSearch = require("./IcdCodeSearch");
Object.keys(_IcdCodeSearch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _IcdCodeSearch[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _IcdCodeSearch[key];
    }
  });
});